<template>
  <div>
    <q-select
      v-model="checklist"
      :options="options"
      class="input-mobile"
      option-label="nome"
      option-value="checkListUuid"
      dense
      behavior="menu"
      use-input
      label="Selecione o Checklist"
      label-color="grey-6"
      outlined
      :multiple="multiple"
      @filter="filtrarChecklist"
    />
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

export default {
  emits: ["enviarChecklist"],
  props: ["resetar", "multiple", "catalogoUuidEspecifico"],
  setup(props, { emit }) {
    const store = useStore();

    const catalogoUuid = salvarCatalogoUuid();
    const checklist = ref(null);
    const options = ref([]);

    const listarChecklist = async (val) => {
      if (
        props.catalogoUuid == undefined &&
        catalogoUuid.catalogoUuid.value === null
      ) {
        options.value = [];
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist", {
          catalogoUuid:
            props.catalogoUuidEspecifico || catalogoUuid.catalogoUuid.value,
          perPage: 100,
          nome: val,
        });
        options.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => checklist.value,
      () => {
        emit("enviarChecklist", checklist.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        checklist.value = "";
      }
    );

    return {
      checklist,
      listarChecklist,
      options,
      catalogoUuid,
      filtrarChecklist(val, update) {
        listarChecklist(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input-mobile {
    font-size: 12px;
  }
}
</style>
